import { WebGPURenderer, PCFSoftShadowMap } from 'three/webgpu'

class WebGPUContext {
	constructor(container, options = {}) {
		if (WebGPUContext.instance) return WebGPUContext.instance

		this.options = { ...WebGPUContext.defaults, ...options }
		this.container = container ?? document.body
		this.pixelRatio = Math.min(window.devicePixelRatio, 2)

		WebGPUContext.instance = this
	}

	async init() {
		this.#createCanvas()
		await this.#setUpRenderer()
	}

	async #setUpRenderer() {
		this.renderer = new WebGPURenderer({
			canvas: this.canvas,
			antialias: false,
			alpha: true,
			forceWebGL: false,
		})

		this.fullScreenDimensions = this.getFullScreenDimensions()

		this.renderer.setSize(this.fullScreenDimensions.width, this.fullScreenDimensions.height)
		this.renderer.setPixelRatio(this.pixelRatio)
		this.renderer.setClearColor(0x000000, 0)
		this.renderer.shadowMap.enabled = true
		this.renderer.shadowMap.type = PCFSoftShadowMap

		await this.renderer.init()
	}

	get isWebGPU() {
		return !!this.renderer?.backend?.isWebGPUBackend
	}

	getFullScreenDimensions() {
		const element = document.createElement('div')

		element.style.height = '100lvh'
		element.style.width = '100lvw'
		element.style.position = 'absolute'
		element.style.visibility = 'hidden'
		document.body.appendChild(element)

		const width = element.offsetWidth
		const height = element.offsetHeight

		document.body.removeChild(element)

		return { width, height }
	}

	#createCanvas() {
		this.canvas = document.createElement('canvas')
		this.canvas.dataset.webgpuCanvas = ''
		this.canvas.style.position = 'fixed'
		this.canvas.style.left = 0
		this.canvas.style.top = 0
		this.canvas.style.zIndex = 35
		this.canvas.style.pointerEvents = 'none'

		this.container.appendChild(this.canvas)
	}

	onResize(width, height) {
		this.pixelRatio = Math.min(window.devicePixelRatio, 2)
		this.fullScreenDimensions = { width, height }
		this.renderer.setSize(width, height)
		this.renderer.setPixelRatio(this.pixelRatio)
	}

	dispose() {
		this.renderer.dispose()
		this.canvas.remove()
		WebGPUContext.instance = null
	}
}

export default WebGPUContext
